import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../Loading/Loading';
import './ResultsPage.css';
import { getAuthToken } from '../../utils';

interface Results {
  _id: string;
  createdAt: string;
  updatedAt: string;
  wave_id: string;
  wavelight_id: string;
  technique: string;
  data: {
    heart_rate_from_peaks: number;
    heart_rate_from_valleys: number;
  };
}

interface ResultsArray {
  techniques: Results[];
}

function ResultsPage() {
  const { id } = useParams<{ id: string }>();
  const [results, setResults] = useState<ResultsArray | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchResults() {
      try {
        const token = getAuthToken();
        const response = await fetch(
          `http://localhost:8080/api/wavelight-backend/wavelight/${id}/results`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const data: ResultsArray = await response.json();
        setResults(data);
      } catch (error) {
        console.error('Error fetching results:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchResults();
  }, [id]);

  return (
    <div className="results-container">
      {loading ? (
        <Loading message="Carregando..." />
      ) : (
        <>
          {results && results.techniques.length > 0 ? (
            <>
              <h2 className="result-title">Resultados do Wavelight {id}</h2>
              <div className="result-table">
                {results.techniques
                  .slice()
                  .reverse()
                  .map((result, index) => (
                    <div key={result._id} className="result-item">
                      <h3 className="title-item">Resultado {index + 1}</h3>
                      <p>
                        <strong>Técnica:</strong> {result.technique}
                      </p>
                      {result.data ? (
                        <div>
                          <p>
                            <strong>ID da técnica:</strong> {result._id}
                          </p>
                          <p>
                            <strong>Batimento cardíaco dos picos:</strong>{' '}
                            {result.data.heart_rate_from_peaks}
                          </p>
                          <p>
                            <strong>Batimento cardíaco dos vales:</strong>{' '}
                            {result.data.heart_rate_from_valleys}
                          </p>
                        </div>
                      ) : (
                        <p>Dados não disponíveis</p>
                      )}
                    </div>
                  ))}
              </div>
            </>
          ) : (
            <h2 className="invalid-id-message">
              Nenhuma técnica disponível para o ID fornecido
            </h2>
          )}
        </>
      )}
    </div>
  );
}

export default ResultsPage;
